import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import {MatStepperModule} from '@angular/material/stepper';

import { LeftContainerComponent } from './components/left-container/left-container.component';
import { SliderContainerComponent } from './components/slider-container/slider-container.component';
import { RightContainerComponent } from './components/right-container/right-container.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared.module';

import { EstimatedTaxSavingsComponent } from './modals/estimated-tax-savings/estimated-tax-savings.component';
import { LifeExpectancyComponent } from './modals/life-expectancy/life-expectancy.component';
import { HsaInvestmentModalComponent } from './modals/hsa-investment-modal/hsa-investment-modal.component';
import { RetirementHealthcareCostsComponent } from './modals/retirement-healthcare-costs/retirement-healthcare-costs.component';
import { InRetirementHealthcareExpensesComponent } from './modals/in-retirement-healthcare-expenses/in-retirement-healthcare-expenses.component';
import { InRetirementHealthcareExpensesFutureComponent } from './modals/in-retirement-healthcare-expenses-future/in-retirement-healthcare-expenses-future.component';
import { PreRetirementHealthcareCostsComponent } from './modals/pre-retirement-healthcare-costs/pre-retirement-healthcare-costs.component';
import { PreRetirementHealthcareExpensesComponent } from './modals/pre-retirement-healthcare-expenses/pre-retirement-healthcare-expenses.component';
import { GenderComponent } from './modals/gender/gender.component';
import { CatchUpContributionComponent } from './modals/catch-up-contribution/catch-up-contribution.component';
import { DependentsExplainedComponent } from './modals/dependents-explained/dependents-explained.component';
import { DependentsNotAddedComponent } from './modals/dependents-not-added/dependents-not-added.component';
import { BasicComponent } from 'src/app/modals/basic/basic.component';

import { CurrencyPipe } from '@angular/common';
import { HsaAreYouSureComponent } from './modals/hsa-are-you-sure/hsa-are-you-sure.component';
import { MoreInfoHcCostComponent } from './modals/more-info-hc-cost/more-info-hc-cost.component';
// import { MedParentPageModule } from './pages/user-form/med-parent-page.module';
// import { UserFormComponent } from './components/user-form/user-form.component';
// import { UserFormModule } from './pages/user-form/user-form.module';
// import { MedCategoriesModule } from './pages/med-categories/med-categories.module';
import { GuideContainerComponent } from './components/guide-container/guide-container.component'
import { EducationalContainerComponent } from './components/educational-container/educational-container.component';
import { EducationalContentComponent } from './components/educational-content/educational-content.component';
import { LessonCategoriesComponent } from './pages/lesson-categories/lesson-categories.component';
import { UserIntroComponent } from './pages/user-intro/user-intro.component';
import { MedicareComponent } from './pages/medicare/medicare.component';
import { UserFormComponent } from './components/user-form/user-form.component';
import { ButtonSelectionComponent } from './components/button-selection/button-selection.component';
import { MedicareDefinitionComponent } from './components/medicare-definition/medicare-definition.component';

@NgModule({
  declarations: [
    AppComponent,
    LeftContainerComponent,
    SliderContainerComponent,
    RightContainerComponent,
    FooterComponent,
    HeaderComponent,
    EstimatedTaxSavingsComponent,
    LifeExpectancyComponent,
    HsaInvestmentModalComponent,
    RetirementHealthcareCostsComponent,
    InRetirementHealthcareExpensesComponent,
    InRetirementHealthcareExpensesFutureComponent,
    PreRetirementHealthcareCostsComponent,
    PreRetirementHealthcareExpensesComponent,
    GenderComponent,
    BasicComponent,
    CatchUpContributionComponent,
    DependentsExplainedComponent,
    DependentsNotAddedComponent,
    HsaAreYouSureComponent,
    MoreInfoHcCostComponent,
    // UserFormComponent,
    GuideContainerComponent,
    EducationalContainerComponent,
    EducationalContentComponent,
    LessonCategoriesComponent,
    UserIntroComponent,
    MedicareComponent,
    UserFormComponent,
    ButtonSelectionComponent,
    MedicareDefinitionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NoopAnimationsModule,
    BrowserAnimationsModule,
    SharedModule,
    MatStepperModule
    // UserFormModule,
    // MedCategoriesModule
    // MedParentPageModule
  ],
  providers: [
    CurrencyPipe,
    MatStepperModule,
    {provide: 'googleTagManagerId',  useValue: 'GTM-5VQGTMG'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
